var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form.form)?_c('form',{attrs:{"id":"payfast-form","method":"POST","action":_vm.form.url}},_vm._l((_vm.form.form),function(value,name){return _c('input',{key:name,attrs:{"type":"hidden","name":name},domProps:{"value":value}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }